
<template>
<div>
    <div class="index" v-if="!detail.show">
        <div class="title">
            <div class="span1">
                <span>通知公告</span>
            </div>
        </div>

        <div>
            <!-- <el-form :inline="true" :model="queryParams" label-width="70px">
                <el-form-item label="">
                    <el-select v-model="queryParams.month" clearable placeholder="选择月份" class="label">
                        <el-option v-for="item in monthList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
				<el-form-item label="">
                    <el-select v-model="queryParams.type" clearable placeholder="" class="label">
                        <el-option v-for="item in typeList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
                    <el-select v-model="queryParams.state" clearable placeholder="教师确认状态" class="label">
                        <el-option v-for="item in stateList" :key="item.id" :label="item.label" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="">
					<el-input v-model="queryParams.name" placeholder="请输入教师姓名"></el-input>
				</el-form-item>
                <el-form-item label="" style="margin-left:20px">
                    <el-button type="primary" size="small" @click='searchFun()'>搜索</el-button>
					<el-button type="primary" style="margin-left:20px" size="small" @click='exportFun()'>导出</el-button>
                </el-form-item>
            </el-form> -->

        </div>
    </div>
    <!-- <Detail :info.sync="detail.info" v-show="detail.show" @to-index="toIndex"></Detail> -->
</div>
</template>
<script>
// import api from '@/api/wisdomSchool/index.js'
export default {
    // components:{
    //     Detail: ()=>import('./detail.vue')
    // },
	data() {
		return {
			pageNum: 1,
			pageSize: 10,
			totalPage: 0,
			queryParams: {
				month: '',
				type:'0',
				state: '',
				class: '',
			},
			monthList:	[],	// 月份列表
			typeList: [{id:'0',label:'全部教师'},{id:'1',label:'校内教师'},{id:'2',label:'机构教师'}],
			stateList: [{id:'1',label:'已确认'},{id:'2',label:'未确认'}],
            detail:{
                info:{title:'赵兵 9月课酬详情'},
                show:false,
            },
		}
	},
	watch:{

	},
	created() {
		// this.getDataList();
	},
	methods: {
		async getDataList() {
			let params = {
				orgId:sessionStorage.getItem('orgId'),
				platformCode:sessionStorage.getItem('platformCode'),
				schoolYearSemester:this.queryParams.semester,
				campusId:this.queryParams.campus,
				classId:this.queryParams.class,
				gradeId:this.queryParams.grade,
				page:this.pageNum,
				limit:this.pageSize,
			}
			// let res = await api.studentClassStatistics(params);
			// if(res.code==='0'){
			// 	this.tableData=res.data?.list || [];
			// 	this.totalPage=res.data?.total || 0;
			// }
		},
		searchFun(){
			this.pageNum=1;
			this.getDataList();
		},
		sizeChangeHandle(val) {
			this.pageSize = val
			this.getDataList()
		},
		currentChangeHandle(val) {
			this.pageNum = val
			this.getDataList()
		},
        toDetail(item){
			// this.detail.info=item;
            this.detail.show=true;
        },
        toIndex(){
            this.detail.show=false;
        },
		exportFun(){},
	},
	mounted() {
		
	},
}
</script>
<style lang="less" scoped>
.index {
	width: 100%;
    padding: 0px 30px 30px 30px;
	.title {
		height: 60px;
		line-height: 48px;
		border-bottom: 1px solid #eaeaea;
		margin-bottom: 20px;
		display: flex;
		justify-content: flex-start;
		.span1 {
			font-family: 'PingFang SC Bold';
			font-weight: bold;
			font-size: 20px;
			text-align: left;
			color: #000;
			margin-right: 30px;
		}
	}

	::v-deep .el-form .el-input__inner {
		width: 150px;
		height: 32px;
		border-radius: 3px;
		background: #fff;
		border: 1px solid #ddd;
	}

	::v-deep .el-table__header tr th {
		background: #f7f7f7;
		box-shadow: 0px 1px 0px #eaeaea;
	}

    ::v-deep .el-date-editor .el-range-separator{
        line-height: 22px;
    }

	.pagination {
		text-align: center;
		margin-top: 30px;
	}
}
</style>
